/**
 * radio input styled specifically for evaluation answers
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

// import third-party libraries
import classNames from 'classnames';

// import utilities
import filterUtils from '../../../global/utils/filterUtils';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

import answerStyles from '../answerModuleStyles.css';

const Radio = ({
  answer
  , change
  , checked
  , loggedInUser
  , questionId
  , userAnswer
}) => {
  // SECURITY: Use userAnswer.correct from server instead of answer.correct
  // answer.correct is undefined for non-admin users
  const isCorrect = userAnswer && userAnswer.correct === true;

  const wrapperClass = classNames(
    'answer-radio answer-wrapper'
    , {
      '-selected': checked
      , '-correct': isCorrect
    }
  )
  const inputClass = classNames(
    "answer-input-display -radio"
    , {
      '-selected': checked
      , '-correct': isCorrect
    }
  )
  return(
    <div className={wrapperClass} onClick={()=> change(answer._id)}>
      <input
        checked={checked}
        className="answer-input"
        name={questionId}
        type="radio"
        value={answer._id}
      />
      <div className={inputClass}>
        <div className='-icon -unchecked '>
          <div className="fal fa-circle fa-xl"/>
        </div>
        <div className='-icon -checked'>
          { isCorrect ?
            <div className=" fas fa-check-circle fa-xl"/>
            :
            <div className="fas fa-times-circle fa-xl"/>
          }
        </div>
      </div>
      <div htmlFor={questionId} className=" -content">{answer.content} { loggedInUser.admin ? <em> &mdash; {answer.correct ? 'correct' : 'wrong'}</em> : null }</div>
    </div>
  )
}

class AnswerRadios extends Base {
  constructor(props) {
    super(props);
    this.state = {
      sortedAnswers: this.props.randomizeOrder ?  filterUtils.randomizeOrder(this.props.answers) : filterUtils.sortByOrderWeight(this.props.answers)
    }
  }

  render() {
    const {
      answers
      , changeAnswer
      , loggedInUser
      , questionId
      , randomizeOrder
      , selectedAnswerId
      , userAnswersByAnswerId
    } = this.props;

    return (
      <div className="-answer-radios">
        { this.state.sortedAnswers.map((answer, i) =>
          <Radio
            answer={answer}
            key={answer._id + i}
            change={changeAnswer}
            checked={answer._id === selectedAnswerId ? true: false}
            loggedInUser={loggedInUser}
            questionId={questionId}
            userAnswer={userAnswersByAnswerId[answer._id]}
          />
        )}
      </div>
    )
  }
}
//
// const AnswerRadios = ({
//   answers
//   , changeAnswer
//   , questionId
//   , randomizeOrder
//   , selectedAnswerId
// }) => {
//   const sortedAnswers = randomizeOrder ? filterUtils.randomizeOrder(answers) : filterUtils.sortByOrderWeight(answers);
//   let theOptions = sortedAnswers.map((answer, i) => {
//     let isChecked = answer._id === selectedAnswerId ? true : false;
//     let inputClass = classNames(
//       'radio-input answer-radio'
//       , { '-selected': isChecked }
//     )
//     return(
//       <div key={i} className={inputClass}>
//         <input
//           checked={isChecked}
//           name={questionId}
//           onChange={(e) => changeAnswer(e.target.value)}
//           type="radio"
//           value={answer._id}
//         />
//         <span htmlFor={questionId} className="display">{answer.content}</span>
//       </div>
//     )
//   })
//   return(
//     <div className="-user-evaluation-answers">
//       {theOptions}
//     </div>
//   )
// }
//

AnswerRadios.propTypes = {
  answers: PropTypes.array.isRequired
  , loggedInUser: PropTypes.object.isRequired
  , questionId: PropTypes.string.isRequired
  , randomizeOrder: PropTypes.bool
  , selectedAnswerId: PropTypes.string
  , userAnswersByAnswerId: PropTypes.object
}

AnswerRadios.defaultProps = {
  randomizeOrder: false
  , selectedAnswerId: ''
  , userAnswersByAnswerId: {}
}

export default AnswerRadios;



// WEBPACK FOOTER //
// modules/answer/components/AnswerRadios.js.jsx